import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import classNames from 'classnames';
import { kebabCase } from 'lodash';
import { lensPath, view } from 'ramda';
import { enabledSelector, labelSelector, newPathSelector } from '../selectors/index';
import entityComposition from '../../common/classes/entityComposition';
import Label from './label';
import logValueOnChange from '../commonActions/logValueOnChange';
const documentsLens = lensPath(['report', 'active', 'reportDocumentObjects']);
const hasAnnotations = document => document && document.reportAnnotationObjects && document.reportAnnotationObjects.length;
const annotationMessage = 'Are you sure you want to remove this document?\nAll of its annotations will be lost.';
const removeMessage = 'Are you sure you want to remove this entry?';
const RemoveButton = _ref => {
  let enabled = _ref.enabled,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label,
    notificationActions = _ref.notificationActions,
    onChange = _ref.onChange,
    path = _ref.path,
    _ref$report = _ref.report,
    report = _ref$report === void 0 ? {} : _ref$report,
    _ref$testingIdentifie = _ref.testingIdentifier,
    testingIdentifier = _ref$testingIdentifie === void 0 ? 'default-id' : _ref$testingIdentifie,
    title = _ref.title;
  // set this content path to null
  const classes = classNames({
    [kebabCase(testingIdentifier)]: true,
    'tqc-control': true,
    't-rb-remove-button': true
  });
  let showAnnotationWarning = false;
  // If this button attempts to remove associatedDocuments with
  // annotations then we need to warn the user.
  if (path && path.includes('associatedDocuments')) {
    // Associated document remove paths are always in the form:
    // /associatedDocument/$documentID
    const reportDocumentID = path.split('/')[2];
    const documentObjects = view(documentsLens)({
      report
    }) || [];
    const document = documentObjects.find(_ref2 => {
      let id = _ref2.id;
      return id === reportDocumentID;
    });
    showAnnotationWarning = hasAnnotations(document);
  }
  // Determine if we need to show the documents warning or not
  const handleChange = () => notificationActions.info({
    message: showAnnotationWarning ? annotationMessage : removeMessage,
    rightButtonLabel: 'Remove',
    rightButtonAction: () => {
      onChange({
        path,
        value: null
      });
    },
    leftButtonLabel: 'Keep',
    id: 'annotation_removal_warning'
  }, {
    autoClose: false // get user feedback before acting
  });
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Label, {
    value: label
  }), /*#__PURE__*/React.createElement(Button, {
    block: true,
    className: classes,
    onClick: handleChange,
    disabled: !enabled
  }, title));
};
RemoveButton.propTypes = {
  enabled: PropTypes.bool.isRequired,
  label: PropTypes.string,
  notificationActions: PropTypes.shape({
    info: PropTypes.func
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  report: PropTypes.shape({}),
  testingIdentifier: PropTypes.string,
  title: PropTypes.string.isRequired
};
export { RemoveButton as UncomposedRemoveButton };
export default entityComposition(RemoveButton, [], {
  enabled: enabledSelector,
  label: labelSelector,
  report: state => state.report,
  onChange: logValueOnChange,
  path: newPathSelector
}, ['notification']);